module.exports = __webpack_public_path__ + "media/images/featured-buskowitz-e7dda2131f44a2f88a37d41004978025.png";